import React, { Component } from 'react';
import { SimilarConfirm } from './Common/SimilarConfirm'
import { GoodsDtl } from '../components/Search/Goods/GoodsDtl'
import { Big3Common, bootstrap } from '../js/IncludeManager'

export const DataContext = React.createContext();

export class Layout extends Component {
    static displayName = Layout.name;
    
    constructor(props) {
        super(props);
        this.state = {
            data: ""
        };
        this.refGoodsDtl = React.createRef();     
    }
    //����Ʈ ���������� ��ǰ�� �̵�
    Layout_GoodsDtl = async (data) => {
        this.ScrollEvent = data.scrollevent;
        await this.refGoodsDtl.current.refCallGoodsData(data.goods_no, data.uid);
        Big3Common.GoodsDtl_ShowHide(data.isshow, data.headhide);
    };
    async componentDidMount() {
        window.parent.CallBakBig3Common(Big3Common, bootstrap);
    }
    
  render() {
    return (
        <div id="wrap">
            <DataContext.Provider value={{ Layout_GoodsDtl: this.Layout_GoodsDtl }}>
                {this.props.children}
            </DataContext.Provider>
            <SimilarConfirm
                callBack={this.Layout_GoodsDtl}
            />
            <div id="child_goods_dtl" className="item_hide">
                <GoodsDtl
                    ref={this.refGoodsDtl}
                />
            </div>
        </div>
    );
  }
}
